import type { PaletteOptions } from '@mui/material';
import React from 'react';

import type { ThemeMode } from '@contexts/index';
import { AppActions, AppContext } from '@contexts/index';

import type { RoutineEvent } from '@models/routine';

export function useApp() {
  const context = React.useContext(AppContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useApp must be used within a AppProvider`);
  }

  const { state, dispatch } = context;

  const selectRoutine = (props: {
    routine: RoutineEvent | null | undefined;
  }) => {
    dispatch({
      type: AppActions.SelectRoutine,
      routine: props.routine ?? undefined,
    });
  };
  const setIsSingleRoutine = (props: {
    isSingleRoutine: boolean | undefined;
  }) => {
    dispatch({
      type: AppActions.SetIsSingleRoutine,
      isSingleRoutine: props.isSingleRoutine,
    });
  };
  const setCustomPalette = React.useCallback(
    (customPalette: PaletteOptions) => {
      dispatch({
        type: AppActions.SetCustomPalette,
        customPalette,
      });
    },
    [dispatch]
  );

  const setThemeMode = React.useCallback(
    (themeMode: ThemeMode) => {
      localStorage.setItem('themeMode', themeMode);

      dispatch({ type: AppActions.SetThemeMode, themeMode });
    },
    [dispatch]
  );

  const reset = () => {
    dispatch({ type: AppActions.Reset });
  };

  return {
    state,
    selectRoutine,
    setIsSingleRoutine,
    setCustomPalette,
    setThemeMode,
    reset,
  };
}
